import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="value"
export default class extends Controller {
  static targets = ["input", "output"]
  connect() {}

  outputTargetConnected() {
    this.updateOutput()
  }

  updateOutput() {
    this.outputTarget.value = this.inputTarget.value
  }
}
